import React, { useState, useEffect } from 'react';
import { Dropdown, List } from 'antd-mobile';
import { CheckOutline } from 'antd-mobile-icons';
import { useFilesArgDispatch } from '../FilesArgContext';
import { FormattedMessage } from 'react-intl';
import styles from './index.module.css';

const TypeSeries = ({ activeTab, typeSeries, hasHandbook, region }) => {
  const filesArgDispatch = useFilesArgDispatch();

  const [state, setState] = useState({
    categories: [],
    activeCategory: { sequence: 0, name: '', id: '' },
    activeSeries: { sequence: 0, name: '', id: '' },
  });

  const { categories, activeCategory, activeSeries } = state;

  const getPathParts = () => {
    const hash = window.location.hash;
    return hash.split('/');
  };

  const navigateTo = (path) => {
    window.location.replace(`#${path}`);
  };

  const isHandbook = (categoryId) => {
    return categoryId?.toLowerCase().includes('handbook');
  };

  // 初始化数据和路由
  useEffect(() => {
    if (typeSeries?.length) {
      const pathParts = getPathParts();
      const currentTab = pathParts[1];
      const currentCategory = pathParts[2];
      const currentSeries = pathParts[3];

      console.log('[TypeSeries debug]', {
        currentTab,
        currentCategory,
        currentSeries,
        typeSeriesIds: typeSeries.map(item => item.id),
        firstCategorySeriesIds: typeSeries[0]?.product_series?.map(s => s.id),
      });

      const categoryIndex = typeSeries.findIndex(item => item.id === currentCategory);
      const targetCategory = categoryIndex !== -1 ? typeSeries[categoryIndex] : typeSeries[0];

      const newActiveCategory = {
        sequence: Math.max(0, categoryIndex),
        name: targetCategory.name,
        id: targetCategory.id,
      };

      if (isHandbook(targetCategory.id)) {
        setState({
          categories: typeSeries,
          activeCategory: newActiveCategory,
          activeSeries: {
            sequence: 0,
            name: '产品宣传册',
            id: 'handbook-list'
          }
        });
        navigateTo(`/${currentTab}/${targetCategory.id}/handbook-list`);
      } else {
        const seriesIndex = targetCategory.product_series.findIndex(item => item.id === currentSeries);
        const targetSeries = seriesIndex !== -1 ? targetCategory.product_series[seriesIndex] : targetCategory.product_series[0];

        console.log('[TypeSeries debug] category match:', categoryIndex, 'series match:', seriesIndex, 'targetSeriesId:', targetSeries?.id);

        setState({
          categories: typeSeries,
          activeCategory: newActiveCategory,
          activeSeries: {
            sequence: Math.max(0, seriesIndex),
            name: targetSeries.name,
            id: targetSeries.id,
          }
        });
        navigateTo(`/${currentTab}/${targetCategory.id}/${targetSeries.id}`);
      }
    }
  }, [typeSeries]);

// 更新文件参数
useEffect(() => {
  if (categories.length === 0) return;

  if (isHandbook(activeCategory.id)) {
    filesArgDispatch({
      type: 'changed',
      entries: [{
        name:  <FormattedMessage id='handbook' />,
        category: 'xuanchuan'
      }],
      product_category: activeCategory.id,  // 保留product_category
      series_id: 'handbook-list',
      category: 'xuanchuan'  // 改为'xuanchuan'
    });
  } else {
    const currentCategory = categories[activeCategory.sequence];
    if (!currentCategory?.product_series) return;

    const currentSeries = currentCategory.product_series[activeSeries.sequence];
    if (!currentSeries?.entries) return;

    filesArgDispatch({
      type: 'changed',
      entries: currentSeries.entries,
      product_category: activeCategory.id,
      series_id: activeSeries.id,
    });
  }
}, [categories, activeCategory, activeSeries, filesArgDispatch]);
  const handleCategoryChange = (category, index) => {
    if (isHandbook(category.id)) {
      setState(prev => ({
        ...prev,
        activeCategory: {
          sequence: index,
          name: category.name,
          id: category.id,
        },
        activeSeries: {
          sequence: 0,
          name: <FormattedMessage id='handbook' />,
          id: 'handbook-list',
        }
      }));
      navigateTo(`/${activeTab}/${category.id}/handbook-list`);
    } else {
      const firstSeries = category.product_series[0];
      setState(prev => ({
        ...prev,
        activeCategory: {
          sequence: index,
          name: category.name,
          id: category.id,
        },
        activeSeries: {
          sequence: 0,
          name: firstSeries.name,
          id: firstSeries.id,
        }
      }));
      navigateTo(`/${activeTab}/${category.id}/${firstSeries.id}`);
    }
  };

  const handleSeriesChange = (series, index) => {
    setState(prev => ({
      ...prev,
      activeSeries: {
        sequence: index,
        name: series.name,
        id: series.id,
      }
    }));
    navigateTo(`/${activeTab}/${activeCategory.id}/${series.id}`);
  };

  return (
    <div style={{ backgroundColor: '#F6F6F6' }}>
      <Dropdown>
        <Dropdown.Item
          key='product_categories'
          title={<div>{categories.length > 0 && activeCategory.name}</div>}
        >
          <List style={{ '--font-size': '3.59vw' }}>
            {categories.map((item, index) => (
              <List.Item
                key={item.id}
                onClick={() => handleCategoryChange(item, index)}
                className={index === activeCategory.sequence ? styles.activeColor : ''}
                arrow={index === activeCategory.sequence && <CheckOutline color="#36a167" fontSize={'5.385vw'} />}
              >
                {item.name}
              </List.Item>
            ))}
          </List>
        </Dropdown.Item>

        {isHandbook(activeCategory.id) ? (
          <Dropdown.Item
            key="handbook_list"
            title={<div> <FormattedMessage id='handbook' /></div>}
          >
            <List style={{ '--font-size': '3.59vw' }}>
              <List.Item> <FormattedMessage id='handbook' /></List.Item>
            </List>
          </Dropdown.Item>
        ) : (
          <Dropdown.Item
            key="product_series"
            title={<div>{categories[activeCategory.sequence]?.product_series?.length > 0 && activeSeries.name}</div>}
          >
            <List style={{ '--font-size': '3.59vw' }}>
              {categories[activeCategory.sequence]?.product_series.map((item, index) => (
                <List.Item
                  key={item.id}
                  onClick={() => handleSeriesChange(item, index)}
                  className={index === activeSeries.sequence ? styles.activeColor : ''}
                  arrow={index === activeSeries.sequence && <CheckOutline color="#36a167" fontSize={'5.385vw'} />}
                >
                  {item.name}
                </List.Item>
              ))}
            </List>
          </Dropdown.Item>
        )}
      </Dropdown>
    </div>
  );
};

export default TypeSeries;
